import { render, staticRenderFns } from "./SolicitudPedido.vue?vue&type=template&id=738224a8&"
import script from "./SolicitudPedido.vue?vue&type=script&lang=js&"
export * from "./SolicitudPedido.vue?vue&type=script&lang=js&"
import style0 from "./SolicitudPedido.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports